import { NgModule } from '@angular/core';
import { IconButtonModule } from '../../directives/icon-button/icon-button.module';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { TranslateModule } from '@ngx-translate/core';
import { NgSelectModule } from '@ng-select/ng-select';

import { EmailTextFormComponent } from './email-text-form.component';
import { TextEditorModule } from '../../components';
import { RnplCommonModule } from 'common/src/modules';

@NgModule({
  declarations: [
    EmailTextFormComponent,
  ],
  imports: [
    IconButtonModule,
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    NgSelectModule,
    TranslateModule,
    TextEditorModule,
    RnplCommonModule
  ],
  exports: [
    EmailTextFormComponent,
  ],
  entryComponents: [EmailTextFormComponent],
})
export class EmailTextFormModule { }
